import React from 'react';

const SectionHeading = ({ index, title, subtitle, className = '' }) => (
  <div className={`mb-14 ${className}`}>
    {index && (
      <p className="mb-4 text-xs font-medium uppercase tracking-[0.18em] text-muted">
        {index}
      </p>
    )}
    <h2 className="text-[28px] font-semibold leading-tight tracking-tight text-body md:text-[40px]">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 max-w-xl text-base leading-relaxed text-muted md:text-lg">
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
